<adm-search (searchEvent)="onSearch($event)"></adm-search>
<div class="dragdrop-wrapper">
  <div class="dragdrop-container">
    <strong>
      {{ leftSideHeader }}
      @if (leftSideList) {
        ({{ noItemsShow }} af {{ leftSideList.totalCount }})
      }
    </strong>
    <div
      cdkDropList
      cdkDropListSortingDisabled
      #leftSide="cdkDropList"
      [cdkDropListData]="filteredList"
      [cdkDropListConnectedTo]="[rightSide]"
      class="dragdrop-list"
      (cdkDropListDropped)="drop($event)">
      @for (item of filteredList; track item) {
        @defer (on viewport) {
          @if (dragDropType === DragDropType.AccessGroupIdTag) {
            <adm-drag-drop-id-tag
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="false"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-id-tag>
          }
          @if (dragDropType === DragDropType.AccessGroupUser) {
            <adm-drag-drop-charging-user
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="false"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-charging-user>
          }
          @if (dragDropType === DragDropType.DepartmentRestriction) {
            <adm-drag-drop-department
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="false"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-department>
          }
        } @placeholder {
          <div></div>
        }
      }
      @if (!disabled() && dragDropType !== DragDropType.DepartmentRestriction) {
        <button mat-raised-button type="button" color="secondary" (click)="onLoadMore()" aria-label="Indlæs flere">Indlæs flere</button>
      }
    </div>
  </div>
  <div class="dragdrop-container">
    <strong>
      {{ rightSideHeader }}
      @if (rightSideList) {
        ({{ rightFilteredList?.length ?? rightSideList.length }} af {{ rightSideList.length }})
      }
    </strong>
    <div
      cdkDropList
      #rightSide="cdkDropList"
      cdkDropListSortingDisabled
      [cdkDropListData]="rightSideList"
      [cdkDropListConnectedTo]="[leftSide]"
      class="dragdrop-list"
      (cdkDropListDropped)="drop($event)">
      @for (item of rightFilteredList ?? rightSideList; track item) {
        @defer (on viewport) {
          @if (dragDropType === DragDropType.AccessGroupIdTag) {
            <adm-drag-drop-id-tag
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="true"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-id-tag>
          }
          @if (dragDropType === DragDropType.AccessGroupUser) {
            <adm-drag-drop-charging-user
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="true"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-charging-user>
          }
          @if (dragDropType === DragDropType.DepartmentRestriction) {
            <adm-drag-drop-department
              class="dragdrop-element"
              [item]="item"
              [parent]="element"
              [removable]="true"
              (update)="onUpdate($event)"
              cdkDrag></adm-drag-drop-department>
          }
        } @placeholder {
          <div></div>
        }
      }
    </div>
  </div>
</div>
